import { BaseIcon } from '@spinwise/react-component-library/BaseIcon';
import styles from './ReplayPreview.module.scss';
import { IconLibrary } from '../../../../../libraries/icons.library';
import { IconVariantsLibrary } from '../../../../../libraries/variants.library';
import { t } from 'i18next';
import { Trans } from 'react-i18next';

export interface IReplayPreview {
  title: string;
  gameName: string;
  amount: string;
  bgImage: string;
  link: string;
  isMobile: boolean;
  onClickReplay: Function;
  country_flag?: string;
}

const ReplayPreview = ({
  title,
  gameName,
  amount,
  bgImage,
  link,
  isMobile,
  onClickReplay,
  country_flag,
}: IReplayPreview) => {
  return (
    <>
      {/* href={link} target='_blank' */}
      <div
        onClick={() => onClickReplay()}
        className={`${styles.replay_preview_container} d-fl`}
        style={{
          background: `url(${bgImage}) no-repeat center center`,
          backgroundSize: 'cover',
        }}
      >
        <div className={`${styles.replay_preview_container_bg} d-fl ai-c jc-c`}>
          <div className={`${styles.replay_preview_container_inner} d-fl ai-fe`}>
            <div
              className={`${styles.button_container} ${
                isMobile == true ? styles.button_container_hover : ''
              } d-fl ai-c`}
            >
              <p>{t('show.win.btn')}</p>
              <div className={styles.icon_container}>
                <BaseIcon iconName={IconLibrary.PlayMobile} variant={IconVariantsLibrary.Black} />
              </div>
            </div>
            <div className={`${styles.bottom_container}`}>
              <div className={`${styles.left_container} d-fl ai-c`}>
                <img src={`/images/icons/flags/${country_flag}.svg`} alt="" />
                <div>
                  <p className={styles.title}>{title}</p>
                  <p className={styles.subtitle}>{gameName}</p>
                </div>
              </div>
              <div className={`${styles.right_container} d-fl ai-c`}>
                <p className={styles.amount}>
                  <Trans
                    components={{
                      AMOUNT: amount as any,
                    }}
                  >
                    replay.preview.win.amount
                  </Trans>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReplayPreview;
